// A window event fired after a service account is connected (OAuth picker, single-account verify,
// Shopify install), so components that depend on the connected accounts — the reporting-currency
// mismatch prompt — recheck without a reload. The route stays mounted through all three flows.
export const SERVICE_ACCOUNT_CONNECTED = 'maya:service-account-connected'

export function announceServiceAccountConnected(organizationId?: number) {
  try {
    window.dispatchEvent(new CustomEvent(SERVICE_ACCOUNT_CONNECTED, { detail: { organizationId } }))
  } catch (err) {
    // an old browser without CustomEvent only loses the live recheck
  }
}
